import { render, staticRenderFns } from "./BenefitTaxSettings.vue?vue&type=template&id=d4bb473e&scoped=true"
import script from "./BenefitTaxSettings.vue?vue&type=script&lang=js"
export * from "./BenefitTaxSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bb473e",
  null
  
)

export default component.exports